import type { ApiStatusSummaryResponse } from '@/openapi/schema';

/**
 * Severity of an API's status, as reported by the v2 backend.
 *
 * Derived from the generated OpenAPI types so it stays in sync with the backend enum.
 */
export type SeverityStatus = ApiStatusSummaryResponse['severity'];

const SEVERITY_ORDER: Record<SeverityStatus, number> = {
  OK: 0,
  INSTABILITIES: 1,
  REDUCED_SERVICE: 2,
};

export const SEVERITY_LABEL: Record<SeverityStatus, string> = {
  OK: 'Operational',
  INSTABILITIES: 'Instabilities',
  REDUCED_SERVICE: 'Reduced',
};

/**
 * Suffix of the severity CSS-module class for each status.
 *
 * Mapped rather than interpolated so that adding a backend enum value is a compile error here,
 * instead of silently rendering an undefined class.
 */
export const SEVERITY_CLASS_SUFFIX: Record<SeverityStatus, string> = {
  OK: 'OK',
  INSTABILITIES: 'INSTABILITIES',
  REDUCED_SERVICE: 'REDUCED_SERVICE',
};

/** The most severe status in the list, or `OK` when the list is empty. */
export function highestSeverity(severities: SeverityStatus[]): SeverityStatus {
  return severities.reduce<SeverityStatus>(
    (highest, severity) => (SEVERITY_ORDER[severity] > SEVERITY_ORDER[highest] ? severity : highest),
    'OK',
  );
}
